import { capture } from "./capture";

export const BiReportsTracking = {
  /** Dashboard detail page opened. */
  detailViewed: (dashboardRk: string) => {
    capture("bi_reports.detail_viewed", { dashboard_rk: dashboardRk });
  },

  /** Instrumentation added via dialog. */
  instrumentationAdded: (dashboardRk: string) => {
    capture("bi_reports.instrumentation_added", { dashboard_rk: dashboardRk });
  },

  /** User report detail page opened. */
  userReportViewed: (userRk: string) => {
    capture("bi_reports.user_report_viewed", { user_id: userRk });
  },
};
